const config = {
    name: 'Center for Små og Mellemstore Virksomheder',
    language: 'en',

    mediaFolder: '/media/',
    manifest: 'assets/json/@lang/manifest.json'
}

// LOCAL DEV ENVIRONMENT
if (window.location.hostname === "localhost") {
    config.manifest = 'https://aucsmvumbraco.azurewebsites.net/output/csmv/assets/json/@lang/manifest.json';
    config.mediaFolder = 'https://aucsmvumbraco.azurewebsites.net/media/';

// ELECTRON PACKAGE
} else if (window.location.hostname === "") {
    config.mediaFolder = 'media/';
}

export default config